import { render, staticRenderFns } from "./Legals.vue?vue&type=template&id=441abfa1&scoped=true&"
import script from "./Legals.vue?vue&type=script&lang=js&"
export * from "./Legals.vue?vue&type=script&lang=js&"
import style0 from "./Legals.vue?vue&type=style&index=0&id=441abfa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441abfa1",
  null
  
)

export default component.exports